export default __webpack_public_path__ + "static/media/GameSpot.5d525770.svg";